/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Starts_In_DaysInputs */

const th_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มในอีก ${i?.days} วัน`)
};

const en_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts in ${i?.days} days`)
};

const ja_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}日後に開始`)
};

const zh_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 天后开始`)
};

const es_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza en ${i?.days} días`)
};

const pt_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa em ${i?.days} dias`)
};

const id_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mulai dalam ${i?.days} hari`)
};

const fr_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commence dans ${i?.days} jours`)
};

const tl_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Magsisimula sa ${i?.days} araw`)
};

const vi_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bắt đầu sau ${i?.days} ngày`)
};

const ko_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}일 후 시작`)
};

const de_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beginnt in ${i?.days} Tagen`)
};

const ru_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начнётся через ${i?.days} дн.`)
};

const tr_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} gün sonra başlıyor`)
};

const it_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia tra ${i?.days} giorni`)
};

const pl_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zaczyna się za ${i?.days} dni`)
};

const uk_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Почнеться за ${i?.days} дн.`)
};

const hi_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} दिनों में शुरू`)
};

const ar_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدأ بعد ${i?.days} أيام`)
};

const ms_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bermula dalam ${i?.days} hari`)
};

const bn_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} দিনে শুরু`)
};

const zh_tw2_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 天後開始`)
};

const zh_hk2_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 天後開始`)
};

const ur_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} دن میں شروع`)
};

const fa_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} روز دیگر آغاز می‌شود`)
};

const sw_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inaanza baada ya siku ${i?.days}`)
};

const nl_starts_in_days = /** @type {(inputs: Starts_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begint over ${i?.days} dagen`)
};

/**
* | output |
* | --- |
* | "Starts in {days} days" |
*
* @param {Starts_In_DaysInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const starts_in_days = /** @type {((inputs: Starts_In_DaysInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starts_In_DaysInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_starts_in_days(inputs)
	if (locale === "ja") return ja_starts_in_days(inputs)
	if (locale === "zh") return zh_starts_in_days(inputs)
	if (locale === "es") return es_starts_in_days(inputs)
	if (locale === "pt") return pt_starts_in_days(inputs)
	if (locale === "id") return id_starts_in_days(inputs)
	if (locale === "fr") return fr_starts_in_days(inputs)
	if (locale === "tl") return tl_starts_in_days(inputs)
	if (locale === "vi") return vi_starts_in_days(inputs)
	if (locale === "ko") return ko_starts_in_days(inputs)
	if (locale === "de") return de_starts_in_days(inputs)
	if (locale === "ru") return ru_starts_in_days(inputs)
	if (locale === "tr") return tr_starts_in_days(inputs)
	if (locale === "it") return it_starts_in_days(inputs)
	if (locale === "pl") return pl_starts_in_days(inputs)
	if (locale === "uk") return uk_starts_in_days(inputs)
	if (locale === "hi") return hi_starts_in_days(inputs)
	if (locale === "ar") return ar_starts_in_days(inputs)
	if (locale === "ms") return ms_starts_in_days(inputs)
	if (locale === "bn") return bn_starts_in_days(inputs)
	if (locale === "zh-TW") return zh_tw2_starts_in_days(inputs)
	if (locale === "zh-HK") return zh_hk2_starts_in_days(inputs)
	if (locale === "ur") return ur_starts_in_days(inputs)
	if (locale === "fa") return fa_starts_in_days(inputs)
	if (locale === "sw") return sw_starts_in_days(inputs)
	if (locale === "nl") return nl_starts_in_days(inputs)
	return en_starts_in_days(inputs)
});